
import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild, signal, WritableSignal } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { FileProgressEvent, FileSendEvent, FileUpload, FileUploadErrorEvent, FileUploadEvent } from 'primeng/fileupload';
import { Image } from 'primeng/image';
import { Attachment, AttachmentService } from 'src/app/api/attachment.service';
import { ConfigService } from 'src/app/config.service';
import { IncidentModalService } from '../modals/incident-modal.service';
import { MessageBoxResults } from '../modals/message-box/message-box.component';


interface DisplayAttachment {
  attachment: Attachment;
  displayUrl: string;

}

@Component({
    selector: 'app-work-item-attachments',
    templateUrl: './work-item-attachments.component.html',
    styleUrls: ['./work-item-attachments.component.scss'],
    providers: [DialogService],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkItemAttachmentsComponent implements OnInit {


  private _workItemId: number = 0;


  public displayAttachments: WritableSignal<DisplayAttachment[]> = signal([])
  public removeActive = signal(false);
  public uploadProgress = signal(0);
  public uploading = signal(false);

  @Input() set workItemId(id: number) {
    this._workItemId = id;
    this.uploadUrl.set(this.config.dataApiUrl + "/incidents/" + id.toString() + "/attachments")
    this.loadExistingAttachments();
  }

  get workItemId(): number {
    return this._workItemId;
  }

  attachments: WritableSignal<Attachment[]> = signal([]);

  uploadUrl = signal("");
  uploadedFiles: WritableSignal<any[]> = signal<any[]>([]);

  @ViewChild('uploadComponent')
  uploadComponent?: FileUpload

  constructor(
    private config: ConfigService,
    private attachmentService: AttachmentService,
    private modalService: IncidentModalService,
    private dialogService: DialogService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
  }


  onSend(event: FileSendEvent) {
    this.uploading.set(true);
  }
  onProgress(event: FileProgressEvent) {
    this.uploadProgress.set( event.progress);
  }

  onUpload(event: FileUploadEvent) {
    for (let file of event.files) {
      this.uploadedFiles.update(files => [...files, file])
    }
    this.resetUpload();
    this.loadExistingAttachments();
  }

  onUploadError(event: FileUploadErrorEvent) {
    this.messageService.add({ severity: 'error', summary: 'Upload Error', detail: 'There was a problem uploading ' + event.files.map((f: any) => f.name).join(', ') });
    console.error(event.error);
    this.resetUpload();
    if (this.uploadComponent) this.uploadComponent.files = [];
  }

  loadExistingAttachments() {
    if (this.workItemId > 0) {
      this.attachmentService.getAttachmentsForIncident(this.workItemId).subscribe((attachments) => {

        const updatedAttachments = [...this.displayAttachments()]

        for (const attachment of this.displayAttachments()) {
          if (attachments.find(a => a.id === attachment.attachment.id) === undefined) {
            updatedAttachments.splice(updatedAttachments.indexOf(attachment), 1);
          }

        }

        for (const attachment of attachments) {
          if (updatedAttachments.find(a => a.attachment.id === attachment.id) === undefined) {
            updatedAttachments.push({
              attachment: attachment,
              displayUrl: attachment.mime.startsWith("image/") ?  attachment.thumbnailUrl : attachment.url
            })
          }
        }

        this.displayAttachments.set(updatedAttachments)


      })

    }
  }


  showPreview(attachment: DisplayAttachment, image: Image) {

    attachment.displayUrl = attachment.attachment.url
  }

  removeAttachment(attachment: DisplayAttachment) {
    this.modalService.showMessageBox(
      this.dialogService, 
      "Remove Attachment", 
      "This attachment will be removed. Are you sure?", 
      { confirmButtonText: "Yes", cancelButtonText: "Cancel" }).onClose.subscribe(
        (result: MessageBoxResults | undefined) => {
          if (result === MessageBoxResults.Confirmed) {
            this.attachmentService.removeAttachment(attachment.attachment.workItemId, attachment.attachment.id).subscribe(() => {
              this.loadExistingAttachments();
            }
            )
          }
        }
      )
  }

  onRemoveToggle() {
    this.removeActive.update(value => !value );
  }

  resetUpload() {
    this.uploadedFiles.set( []);
    this.uploadProgress.set(0);
    this.uploading.set(false);
  }




}
